const AccountsQ = {
    topic: 'Accounts',
    level: 'Beginner',
    totalQuestions: 15,
    perQuestionScore: 1,
    questions: [
       {
         question:
           'The revenues and expenses of a company are displayed in which statement?',
         choices: ['Balance Sheet', 'Cash Flow Statement', 'Income Statement','None of the Above'],
         type: 'MCQs',
         correctAnswer: 'Income Statement',
       },
       {
         question:
           'The main Purpose of Financial Accounting is?',
         choices: ['To Provide financial information to shareholders','To maintain balance sheet', 'To minimize taxes','To keep track of liabilities'],
         type: 'MCQs',
         correctAnswer: 'To Provide financial information to shareholders',
       },
       {
         question:
           'The expanded accounting equation is used by which statement?',
         choices: [ 'Flow Statement','Balance Sheet','Income Statement','None of the Above'],
         type: 'MCQs',
         correctAnswer: 'Balance Sheet',
       },
       {
         question: 'What type of balance do asset accounts have?',
         choices: ['Contra','Credit','Debit','All of the Above'],
         type: 'MCQs',
         correctAnswer: 'Credit',
       },
       {
         question: 'The kind of debts which are needed to be repaid in a short term is known as?',
         choices: ['Fixed Liabilities' , 'Current Liabilities' , 'Depreciating Assets' , 'Intangible Assets'],
         type: 'MCQs',
         correctAnswer: 'Current Liabilities'     
        },
       {
         question: 'The account which increases equity is known as?',
         choices: ['Debit Account' , 'Credit Account', 'Revenue' , 'Treasury Stock'],
         type: 'MCQs',
         correctAnswer: 'Revenue',
       },
       {
         question: 'What are the long-term assets which do not have any physical existence?',
         choices: ['Intangible Assets','Tangible Assets','Current Liabilities','Current Assets'],
         type: 'MCQs',
         correctAnswer: 'Intangible Assets',
       },
       {
         question: 'What is the supporting evidence in a business transaction called?',
         choices: ['Journal','Ledger','Voucher','Contra Voucher'],
         type: 'MCQs',
         correctAnswer: 'Journal',
       },
      {
        question: 'The Expenses, Profit & Loss of an organisation are recorded in which account?',
        choices: ['Current Account' , 'Personal Account', 
        'Nominal Account' , 'None of the above' ],
        type: 'MCQs',
        correctAnswer: 'Nominal Account',
      },
      {
        question: 'Which person owes an amount to a business organisation for buying goods and services on a credit basis? ',
        choices: ['Creditors','Debtors','Owner','None of the above'],
        type: 'MCQs',
        correctAnswer: 'Debtors',
      },
      {
        question: 'The sales income (Credit and Cash) of a business during a given period is called',
        choices: ['Transactions','Sales Returns','Turnover','Purchase Returns'],
        type: 'MCQs',
        correctAnswer: 'Turnover',
      },
      {
        question: 'Any written evidence in support of a business transaction is called',
        choices: ['Journal', 'Ledger', 'Ledger Posting', 'Voucher'],
        type: 'MCQs',
        correctAnswer: 'Voucher',
      },
      {
        question: 'In Journal, the business transaction is recorded',
        choices: ['Same Day', 'Next Day', 'Once in a week', 'Once in a Month'],
        type: 'MCQs',
        correctAnswer: 'Same Day',
      },
      {
        question: 'Real Account Records',
        choices: ['Dealings with creditors or debtors', 'Dealings in commodities', 'Gains and Losses', 'All of the Above'],
        type: 'MCQs',
        correctAnswer: 'Dealings in commodities',
      },
      {
        question: 'The following is a statement showing the financial status of the company at any given time',
        choices: ['Trading Account', 'Profit & Loss Statement','Balance Sheet', 'Cash Book'],
        type: 'MCQs',
        correctAnswer: 'Balance Sheet',
      },
     
    ],
  }
export default AccountsQ